<template>
  <div class="page__keyword a-page">
    <div style="background-color:white; padding: 4px; border-radius: 4px; overflow: hidden">
      <el-row>
        <el-col :sm="12">
          <div style="height: 10px"></div>
          <el-select v-if="false" size="small" :placeholder="$t('select.shop')" v-model="shopee_shop.selected"
                     filterable>
            <el-option-group :label="$t('shop.added')">
              <el-option v-for="item in shopee_shop.list.filter(i => !i.is_sub_account)" :key="item.username"
                         :label="`${item.username} ${item.name}`" :value="item._id">
                <div>
                  <table style="width:100%;">
                    <tbody>
                    <tr>
                      <td style="width:40px;">
                        <img style="width:28px; height:28px; border-radius: 50vh;"
                             :src="logo_channel(item.channel)"
                             alt="image">
                      </td>
                      <td style="padding-left:10px;">
                        {{ item.username }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </el-option>
            </el-option-group>
            <el-option-group :label="$t('shop.managed')">
              <el-option v-for="item in shopee_shop.list.filter(i => i.is_sub_account)" :key="item.username"
                         :label="`${item.username} ${item.name}`" :value="item._id">
                <div>
                  <table style="width:100%;">
                    <tbody>
                    <tr>
                      <td style="width:40px;">
                        <img style="width:28px; height:28px; border-radius: 50vh;"
                             :src="logo_channel(item.channel)"
                             alt="image">
                      </td>
                      <td style="padding-left:10px;">
                        {{ item.username }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </el-option>
            </el-option-group>
          </el-select>
          <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"></shop-select>
          &nbsp;&nbsp;&nbsp;
          <el-button size="small" class="el-icon-folder" type="primary"
                     @click="m__show_keyword_manager">&nbsp;{{ $t('keyword.saved_files') }}
          </el-button>
        </el-col>
        <el-col :sm="12" class="text-right" style="padding-top: 3px; padding-right: 10px">
        </el-col>
      </el-row>

      <div style="margin-top: 10px">
        <el-alert v-if="m__is_trial()" style="margin: 15px 0 10px 0;" type="warning" show-icon
                  :title="$t('base.attention')"
                  :description="`${$t('keyword.limit_message')}: ${remaining_search}`">
        </el-alert>

        <component__fff-com-vn :key="component_key"
                               :keywords="selected_keyword"
                               :shop="shop"
                               :sp_user="seller"
                               :product_list="product_list"
                               :fff="fff"
                               @pick="m__try_add_item_key"
                               @search="m__get_remaining_search"></component__fff-com-vn>

        <div class="text-right" style="padding:5px; margin-top: 10px">
          <el-button size="mini" type="info" @click="m__select_top_100_keywords">
            {{
              $t('base.select_top_x_y', {
                x: 100,
                y: $t('base.keyword')
              })
            }}
          </el-button>
          <el-button size="mini" type="info" @click="m__uncheck_all_keywords">
            {{ $t('base.unselect_all_x', {x: $t('base.keyword')}) }}
          </el-button>
          <el-button size="mini" type="info" @click="m__export_excel" :loading="loading.export_excel">
            <span class="el-icon-download"></span>
            {{ $t('base.download_excel') }}
          </el-button>
          <el-button size="mini" type="danger" @click="m__delete_all">
            <span class="el-icon-delete"></span>
            {{ $t('base.delete_selected_x', {x: this.$t('base.keyword')}) }}
          </el-button>
          <el-button size="mini" type="primary" @click="m__add_all">
            <span class="el-icon-plus"></span>
            {{ $t('base.add_selected_x', {x: this.$t('base.keyword')}) }}
          </el-button>
          <el-button size="mini" type="primary" @click="m__show_current_keyword">
            <span class="ti-paint-roller"></span>
            {{ $t('keyword.open_current_keyword') }}
          </el-button>
        </div>
      </div>
    </div>

    <el-dialog :width="fff_tab===1?'1300px':'700px'" :close-on-click-modal="false" :visible.sync="fff_tool"
               custom-class="no-body">
      <div slot="title"
           style="position: relative; padding:0!important; overflow: hidden; border-radius: 8px!important;">
        <div v-show="fff_tab===2">
          <div style="margin-top: 15px; padding:10px">
            <el-row>
              <el-col :sm="8" :xs="12">
                <el-button size="mini" type="primary"
                           @click="() => {this.fff_tool=false; this.EB.$emit('focus_fff')}">
                  <span class="el-icon-search"></span>
                  {{ $t('base.open') }} {{ $t('menu.atosa_keyword_tool') }}
                </el-button>
              </el-col>
              <el-col :sm="16" :xs="12" class="text-right">
                <a href="javascript:void(0);" class="a-link" @click="m__choose_excel_file"
                   style="margin-right: 5px">
                  <span class="ti-harddrives"></span>
                  {{ $t('base.import_from_excel') }} |</a>
                <a href="javascript:void(0);" class="a-link" @click="keyword_manager.show=true"
                   style="margin-right: 5px">
                  <span class="ti-harddrives"></span>
                  {{ $t('keyword.saved_files') }} |</a>
                <el-button style="webkit-app-region:no-drag; " size="mini" class="ti-save"
                           @click="m__initial_save_keyword_file">&nbsp;{{ $t('keyword.save_file') }}
                </el-button>
              </el-col>
            </el-row>

            <div class="table table-responsive" style="margin:30px 0;">
              <table class="table">
                <thead>
                <tr>
                  <th>#</th>
                  <th>{{ $t('base.keyword') }}</th>
                  <th>{{ $t('base.volume') }}</th>
                  <th>{{ $t('base.recommend_price') }}</th>
                  <th>{{ $t('base.your_price') }}</th>
                  <th>{{ $t('base.delete') }}</th>
                </tr>
                </thead>
                <tbody>
                <template v-if="selected_keyword.length===0">
                  <tr>
                    <td class="text-center" colspan="6">
                      {{ $t('keyword.has_no_keyword') }} ...
                    </td>
                  </tr>
                </template>
                <template v-for="(item ,index) in selected_keyword">
                  <tr>
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.keyword }}</td>
                    <td class="text-right">{{ item.sp_volume | currency }}</td>
                    <td class="text-right">{{ item.sp_price | currency }}</td>
                    <td>
                      <el-input-number :min="0" :max="999999999" v-model="item.price"
                                       controls-position="right" size="mini"></el-input-number>
                    </td>
                    <td>
                      <el-button size="mini" @click="m__remove_select_keyword_by_index(index)">
                        {{ $t('base.delete') }}
                      </el-button>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
            <el-button size="mini" type="success" icon="ti-plus" @click="add_keyword.show=true">&nbsp;
              {{ $t('keyword.add_keywords') }}
            </el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="selected_keyword = []">
              {{ $t('base.delete_all_x', {x: this.$t('base.keyword')}) }}
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="1000px" :close-on-click-modal="false" :visible.sync="keyword_manager.show"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <component__keyword_file_manager ref="component_keyword_file_manager"
                                         :user="seller"
                                         :product_id="add_keyword.product_id"
                                         :shop="shop"
                                         @add_to_recent="m__add_to_recent_keyword"></component__keyword_file_manager>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="save_keyword_file.show" :close-on-click-modal="false" custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('base.filename') }}</p>
        <el-input size="mini" :placeholder="$t('input.filename')"
                  v-model="save_keyword_file.filename"></el-input>
        <div style="padding-top:20px;" class="text-right">
          <el-button size="mini" icon="el-icon-close" @click="save_keyword_file.show=false">
            {{ $t('base.close') }}
          </el-button>
          <el-button size="mini" icon="ti-save" :loading="save_keyword_file.loading" type="primary"
                     @click="m__try_save_keyword_file"> &nbsp;{{ $t('base.save_file') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="600px" :close-on-click-modal="false" :visible.sync="add_keyword.show" custom-class="no-body">
      <div slot="title" style="padding:10px;">
        <template v-if="add_keyword.product_id===0">
          <div style="background-color: orangered; color:white; text-align:center; padding:10px; border-radius: 4px;">
            {{ $t('keyword.has_no_connected_message') }}
          </div>
        </template>
        <template v-else>
          <br>

          <el-input size="mini" :placeholder="$t('input.placeholder')"
                    v-model="add_keyword.keyword" style="margin-top: 10px"></el-input>
          <div class="table-responsive">
            <table class="table table-hover" style="margin-top:5px">
              <thead>
              <tr>
                <th>#</th>
                <th>
                  <!--<el-checkbox v-model="add_keyword.checked"></el-checkbox>-->
                </th>
                <th>{{ $t('base.keyword') }}</th>
                <th class="text-right">{{ $t('base.volume') }}</th>
                <th class="text-right">{{ $t('base.recommend_price') }}</th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(item,index) in c__add_keyword_display_list">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>
                    <el-checkbox v-model="item.checked"></el-checkbox>
                  </td>
                  <td>{{ item.keyword }}</td>
                  <td class="text-right">{{ item.sp_volume | currency }}</td>
                  <td class="text-right">{{ item.sp_price | currency }}</td>
                </tr>
              </template>
              </tbody>
            </table>
            <el-pagination :current-page.sync="add_keyword_filter.current_page"
                           :page-size="add_keyword_filter.page_size"
                           layout="prev, pager, next, total" :total="add_keyword.data.length"/>
          </div>
          <div style="padding-top:20px;" class="text-right">
            <el-button size="mini" icon="el-icon-close" @click="add_keyword.show=false">{{
                $t('base.close')
              }}
            </el-button>
            <el-button size="mini" icon="el-icon-check" type="primary" @click="m__add_selected_keyword"
                       :disabled="c__add_keyword__data_checked.length===0"> {{ $t('base.add') }}
              ({{ c__add_keyword__data_checked.length }}) {{ $t('base.x_selected', {x: $t('base.keyword')}) }}
            </el-button>
          </div>
        </template>
      </div>
    </el-dialog>

    <input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" type="file"
           @change="m__import_excel_file" id="input_control" style="display: none;">
  </div>
</template>

<script>
import component__keyword_file_manager from './component__keyword_file_manager'
import Component__fffComVn from './component__fff'
import readXlsxFile from 'read-excel-file'
import {drop as _drop, take as _take} from 'lodash'
import {check_feature, show_expr_notification} from '../../addon/check_license'
import {get_shop_mixins} from '../../mixins/get_shop';
import {fix_ads_mixins} from "../../mixins/fix_ads";
import {FFF_COM_VN} from "../../addon/fff";
import {global_shops} from "../../addon/global_config";
import {make_uuid} from "../../addon/ads_function";

export default {
  name: 'page__keyword',

  mixins: [get_shop_mixins, fix_ads_mixins],

  components: {
    component__keyword_file_manager,
    Component__fffComVn
  },

  data() {
    return {
      add_keyword_filter: {
        page_size: 10,
        current_page: 0
      },
      fff_tab: 2,
      fff_tool: false,
      loading: {
        export_excel: false,
        get_products: false
      },
      seller: null,
      selected_keyword: [],
      product_list: [],
      save_keyword_file: {
        show: false,
        loading: false,
        filename: 'File keyword'
      },
      keyword_manager: {
        show: false
      },
      add_keyword: {
        checked: false,
        keyword: '',
        show: false,
        loading: false,
        data: [],
        // sp_user: new SPUserV4(),
        sp_user: null,
        product_id: 0
      },
      change_price: {
        show: false,
        apply_field: 'sp_price',
        type: 'PERCENT',
        func: 'SUB',
        percent: 20,
        value: 1000
      },
      remaining_search: 0,
      fff: null,
      component_key: null
    }
  },

  beforeRouteEnter(to, from, next) {
    if (check_feature('keyword_tool')) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  async beforeMount() {
    await this.m__get_shopee_shop()
    await this.m__get_remaining_search()
  },

  watch: {
    'shopee_shop.selected': function () {
      this.component_key = make_uuid()
      this.m__initial_view()
    },

    'add_keyword.keyword': function () {
      this.m__search_sp_keyword()
    }
  },

  computed: {
    c__add_keyword__data_checked() {
      return this.add_keyword.data.filter(e => e.checked)
    },

    c__add_keyword_display_list() {
      const limit = this.add_keyword_filter.page_size
      const skip = limit * (this.add_keyword_filter.current_page - 1)

      return _take(_drop(this.add_keyword.data, skip), limit)
    }
  },

  methods: {
    async m__get_remaining_search() {
      const resp = await this.$http.get(this.API.URL_API_SRV_2 + '/keyword/search_number', this.cf())
      this.remaining_search = resp.body.data.remain
    },

    m__is_trial() {
      const pack = this.$store.state.package && this.$store.state.package.extend_package && this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing')
      return pack && pack.package && pack.package.default_for_free
    },

    m__open_cctk() {
      if (!this.m__is_allow_keyword_tool()) {
        this.ntf_w(this.$t('package.not_for_trial'))
        return
      }

      if (!this.shopee_shop.selected) {
        this.ntf_w(this.$t('shop.select_for'))
        return
      }
      this.fff_tool = false
    },

    m__is_allow_keyword_tool() {
      const extent_package = this.$store.state.package.extend_package ? this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing') : null
      if (extent_package) {
        return !!(this.dayjs().isBefore(this.dayjs(new Date(extent_package.license_to)), 's') &&
          extent_package.package.extra_data && extent_package.package.extra_data.marketing &&
          extent_package.package.extra_data.marketing.keyword_tool)
      } else {
        return false
      }
    },

    m__show_keyword_manager() {
      if (!this.shopee_shop.selected) {
        this.ntf_w(this.$t('shop.select_for'))
        return
      }
      this.keyword_manager.show = true
    },

    m__show_current_keyword() {
      if (!this.m__is_allow_keyword_tool()) {
        this.ntf_w(this.$t('package.not_for_trial'))
        return
      }

      if (!this.shopee_shop.selected) {
        this.ntf_w(this.$t('shop.select_for'))
        return
      }

      this.fff_tab = 2
      this.fff_tool = true
    },

    async m__initial_view() {
      if (this.shopee_shop.selected.length > 6) {
        let items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)
        if (items.length > 0) {
          const shop = items[0]

          // todo: check role
          if (!this.check_role(shop, 'marketing', 'keyword_tool')) {
            this.shopee_shop.selected = ''
            return
          }

          this.shop = shop
          this.seller = await this.init_seller(this.shop)

          if (!await this.check_shop(this.seller)) {
            this.shopee_shop.selected = ''
            return
          }

          if (this.shop.is_sub_account && !this.check_role(this.shop, 'marketing', 'keyword_tool')) {
            this.shopee_shop.selected = ''
            return
          }

          this.fff = new FFF_COM_VN()
          if (this.shop.extra_data && this.shop.extra_data.is_global && this.shop.extra_data.country) {
            const global_found = global_shops.find(i => i.country === this.shop.extra_data.country)
            if (global_found && global_found.fff_config) {
              this.fff.lang = global_found.fff_config.lang
              this.fff.country = global_found.fff_config.country
            }
          }

          this.m__get_shop_product_list()
            .then(() => console.log('get product successfully'))

          let page_one = await this.seller.get_product_by_page(1)
          if (page_one.length > 0) {
            this.add_keyword.product_id = page_one[0].id
          } else {
            this.add_keyword.product_id = 0
          }
          this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)
        }
      }
    },

    async m__get_shop_product_list() {
      this.loading.get_products = true
      this.product_list = []

      let offset = 0, limit = 50
      let product_resp = await this.seller.marketing_product_selector(offset, limit, 'search')
      product_resp.data.item_list.forEach(i => {
        i.id = i.itemid
        i.checked = false
      })
      this.product_list.push(...product_resp.data.item_list)

      while (product_resp.data.item_list && product_resp.data.item_list.length) {
        offset += limit
        product_resp = await this.seller.marketing_product_selector(offset, limit, 'search')
        product_resp.data.item_list.forEach(i => {
          i.id = i.itemid
          i.checked = false
        })
        this.product_list.push(...product_resp.data.item_list)
      }

      this.loading.get_products = false
    },

    m__try_add_item_key(keyword) {
      let new_keyword = JSON.parse(JSON.stringify(keyword))
      if (new_keyword.item) {
        this.selected_keyword.push({
          ...new_keyword.item,
          price: new_keyword.item.sp_price
        })
      } else {
        this.selected_keyword.push({
          ...new_keyword,
          price: new_keyword.sp_price
        })
      }

      if (keyword.move) {
        this.fff_tab = 2
      }
    },

    m__select_top_100_keywords() {
      this.EB.$emit('m__select_top_100_keywords')
    },

    m__uncheck_all_keywords() {
      this.EB.$emit('m__uncheck_all_keywords')
    },

    m__export_excel() {
      this.loading.export_excel = true
      this.EB.$emit('m__export_excel_keyword')
      this.loading.export_excel = false
    },

    m__add_all() {
      this.EB.$emit('m__add_all')
    },

    m__delete_all() {
      this.EB.$emit('m__delete_all')
    },

    m__choose_excel_file() {
      if (!this.shopee_shop.selected) {
        this.show_dialog.shop_not_selected = true
        return
      }

      this.$el.querySelector(`#input_control`).click()
    },

    m__initial_save_keyword_file() {
      if (this.selected_keyword.length > 0) {
        this.save_keyword_file.filename = `${this.$t('keyword.file')} ${this.selected_keyword[0].keyword} (${this.selected_keyword.length} ${this.$t('base.keyword')} - ${this.$t('base.at')} ${this.timeFormat(new Date())})`
        this.save_keyword_file.show = true
      } else {
        this.ntf_w(this.$t('keyword.empty_to_save'))
      }
    },

    m__remove_select_keyword_by_index(index) {
      this.selected_keyword.splice(index, 1)
    },

    m__add_to_recent_keyword(keyword_file) {
      this.keyword_manager.show = false

      for (const item of keyword_file.keyword_json) {
        const selected_item = this.selected_keyword.find(i => i.keyword === item.keyword)
        if (selected_item) {
          Object.assign(selected_item, {...item})
        } else {
          this.selected_keyword.push(item)
        }
      }
    },

    async m__import_excel_file(e) {
      try {
        const file_store = e.target.files || e.dataTransfer.files
        if (file_store.length === 0) {
          return
        }

        const keywords = []
        const raw = await readXlsxFile(file_store[0])
        for (const row of raw) {
          if (row && row[0]) keywords.push(row[0])
        }
        // console.log(keywords)

        for (const keyword of keywords) {
          if (this.product_list.length > 0) {
            const info = await this.seller.marketing_get_keyword_volume(keyword, this.add_keyword.product_id)
            if (info) {
              info.sp_volume = info.search_volume
              info.sp_price = this.m__calculate(info.recommend_price)
              const k = this.selected_keyword.find(i => i.keyword === info.keyword)
              if (k) {
                Object.assign(k, info)
              } else {
                this.selected_keyword.push({
                  ...info,
                  price: info.sp_price
                })
              }
            }
          } else {
            this.ntf_w(this.$t('base.create_at_least_product'))
          }
        }
      } catch (e) {
        console.log(e)
        this.ntf_w(this.$t('base.error_reading_file'))
      }
    },

    m__try_save_keyword_file() {
      this.confirm(this.$t('keyword.confirm_save_file_x_name', {x: this.save_keyword_file.filename}), () => {
        this.save_keyword_file.loading = true

        this.$http.post(this.API.marketing.keyword_file.add, {
          filename: this.save_keyword_file.filename,
          keyword_json: this.selected_keyword
        }, this.cf())
          .then(async (resp) => {
            this.ntf_s(resp)
            this.$refs['component_keyword_file_manager'].m__get_keyword_file()
            this.save_keyword_file.loading = false
            this.save_keyword_file.show = false
            // await this.m__get_keyword_file()
            this.EB.$emit('m__try_save_keyword_file')
          })
          .catch(error => {
            console.error(error)
            this.ntf_w(error)
            this.save_keyword_file.loading = false
          })
      })
    },

    m__add_selected_keyword() {
      this.add_keyword.show = false
      let keyword_text_list = this.selected_keyword.map(e => e.keyword)
      this.c__add_keyword__data_checked.forEach(e => {
        if (!keyword_text_list.includes(e.keyword)) {
          this.m__try_add_item_key(e)
        }
      })
    },

    async m__search_sp_keyword() {
      let current_keyword = this.add_keyword.keyword
      await this.sleep(1000)

      if (current_keyword === this.add_keyword.keyword) {
        let hint_keywords = await this.seller.marketing_get_hint_keyword(current_keyword)
        if (current_keyword === this.add_keyword.keyword) {
          this.add_keyword.data = hint_keywords.map(e => {
            return {
              ...e,
              checked: false,
              sp_price: 0,
              sp_volume: 0
            }
          })

          if (new RegExp(/\s$/ig).test(current_keyword)) {
            const alpha = 'abcdefghijklmnopqrstuvwxyz0123456789'
            for (const item of alpha.split('')) {
              let hint_keywords_sub = await this.seller.marketing_get_hint_keyword(current_keyword + item)
              hint_keywords_sub.forEach(e => {
                if (!this.add_keyword.data.find(i => i.keyword === e.keyword_filter)) {
                  this.add_keyword.data.push({
                    ...e,
                    checked: false,
                    sp_price: 0,
                    sp_volume: 0
                  })
                }
              })
            }
          }
        }
        this.add_keyword.data.forEach(e => {
          this.m__get_sp_keyword_info(e)
        })

        const suggest_keywords_resp = await this.add_keyword.sp_user.marketing_suggest_keywords(this.keyword, this.campaign.product.itemid)
        for (const item of suggest_keywords_resp.data) {
          if (!this.add_keyword.some(i => i.keyword === item.keyword)) {
            this.add_keyword.push({
              ...item,
              checked: false,
              sp_volume: item.search_volume,
              sp_price: this.m__calculate(item.recommend_price)
            })
          }
        }
      }
    },

    async m__get_sp_keyword_info(keyword) {
      try {
        try {
          let info = await this.seller.marketing_get_keyword_volume(keyword.keyword, this.add_keyword.product_id)
          if (info !== null) {
            keyword.sp_volume = info.search_volume
            keyword.sp_price = this.m__calculate(info.recommend_price)
          }
        } catch (e) {
        }
      } catch (e) {
      }
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/keyword/index.vue